module.exports = __webpack_public_path__ + "img/noAdopt.a7892886.png";